<template>
  <div class="tags">
    <div
      @click="toggle(getValue(item))"
      :class="{ active: value.includes(getValue(item)) }"
      class="tag"
      v-for="item in list"
      :key="item.id"
    >
      {{ getText(item) }}
    </div>
  </div>
</template>

<script>
export default {
  name: "Tags",
  props: {
    value: Array,
    list: Array,
    itemText: [String, Function],
    itemValue: [String, Function],
  },
  methods: {
    getText(item) {
      if (typeof this.itemText == "function") {
        return this.itemText(item);
      } else {
        return item[this.itemText];
      }
    },
    getValue(item) {
      if (typeof this.itemValue == "function") {
        return this.itemValue(item);
      } else {
        return item[this.itemValue];
      }
    },
    toggle(itemValue) {
      if (this.value.includes(itemValue)) {
        this.$emit(
          "input",
          this.value.filter((id) => id != itemValue)
        );
      } else {
        this.$emit("input", [...this.value, itemValue]);
      }

      this.$emit("changed");
    },
  },
};
</script>

<style scoped lang="scss">
.tags {
  display: flex;
  flex-wrap: wrap;
  margin: auto;
  align-items: center;
  justify-content: center;
  max-width: 1000px;
}

.tag {
  background: #ffffff;
  border: 1px solid #c4c4c4;
  color: #c4c4c4;
  border-radius: 22px;
  margin: 5px;
  font-family: "Roboto", sans-serif;
  font-weight: 600;
  font-size: 0.875em;
  letter-spacing: 0.05em;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  cursor: pointer;
  transition: 0.3s;
  text-transform: uppercase;

  &:hover {
    border-color: #012169;
    color: #012169;
  }

  &.active {
    border-color: #012169;
    background: #012169;
    color: white;
  }
}
</style>
